<template>
  <div class="animated fadeIn">
    <b-card :class="`info-header-card`" no-body>
      <b-card-header v-if="header || $slots['header']">
        <span v-if="header" class="text-muted text-uppercase">
          <i v-if="icon" :class="`fal fa-${icon} mr-2`" />
          {{ header }}
        </span>
        <slot name="header" />
      </b-card-header>
      <div v-if="$slots['body_top_slot']" class="py-3 px-4">
        <slot name="body_top_slot" />
      </div>
      <div v-if="formatted_rows.length" class="py-3 px-4">
        <b-row class="pr-3">
          <b-col
            v-for="(row, rowIndex) in formatted_rows"
            :key="rowIndex"
            sm="12"
            md="6"
            class="pr-0"
          >
            <b-row class="pr-3">
              <b-col v-if="row.label" class="pr-0">
                <label class="font-weight-bold">
                  {{ row.label }}
                </label>
              </b-col>
              <b-col class="pr-0">
                <span v-if="!hasSlot(row.slot)">{{ row.value }}</span>
                <slot v-else :name="row.slot" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div v-if="$slots['body_bottom_slot']" class="py-3 px-4">
        <slot name="body_bottom_slot" />
      </div>
      <b-card-footer v-if="footer || $slots['footer_slot']">
        <span class="text-muted text-uppercase">
          {{ footer }}
        </span>
        <slot name="footer_slot" />
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "InfoHeaderCard",
  props: {
    icon: {
      type: String,
      default: null,
    },
    header: {
      type: String,
      default: null,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    footer: {
      type: String,
      default: null,
    },
  },
  computed: {
    formatted_rows() {
      const rows = [];

      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].value) {
          const row = this.rows[i];

          !row.slot &&
            (row.slot = row.label ? row.label.replace(/\s+/g, "") : `row-${i}`);
          rows.push(row);
        }
      }

      return rows;
    },
  },
  methods: {
    hasSlot(name = "default") {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
};
</script>
